(function ($) {

  "use strict";

  $(document).ready(function() {
  	keyboard_accessibility();
  });
  
  // Keyboard accessibility
  function keyboard_accessibility() {
    $(document).keydown(function(e) {
      var code = (e.keyCode ? e.keyCode : e.which);

      // ESC behaviors
      if (code == 27) {
        
      }

      // TAB behaviors
      if (!e.shiftKey && code == 9) {

          // $('.main-menu__list-item--subnav:last-child > a').on({
          //   'blur': function() {
          //     $('.submenu-is-open').removeClass('submenu-is-open');
          //     //$(this).parents('.main-menu__item').next('.main-menu__item').find('.main-menu__link').focus();
          //   }
          // });

          $('.main-menu__item > .main-menu__link').on({
            'focus': function() {
              closeSubmenus();
            }
          });

          $('.search-toggle:not(.active)').on({
            'focus': function() {
              closeSubmenus();
            },

          });
          $('.search-toggle.active').on({
            'focus': function() {
              $('.search-bar__field input').focus();  
            },
          });

          $('.search-bar__button button').on({
            'blur': function() {
              $('.search-toggle').trigger('click');
            }
          });
      }

      // SHIFT + TAB behaviors
      if (e.shiftKey && code == 9) {
        $('.search-bar__field input').on({
          'blur': function() {
            $('.search-toggle').focus();
          }
        })
      }

      // ENTER behaviors
      if (code == 13) {
        if ( $('.search-toggle').is(':focus') ) {
          setTimeout(function() {
            $('.search-bar__field input').focus();  
          }, 100);
        }
      }
    });
  }

  function closeSubmenus() {
    var $html = $('html'),
        $main_menu = $('.main-menu');

    $main_menu.find('.submenu--revealed').removeClass('submenu--revealed').attr('aria-expanded', false);
    $main_menu.find('.main-menu__submenu-container.active').removeClass('active').hide();
    $html.removeClass('submenu-is-open');
  }

})(jQuery);